import { Box } from '@mui/material'
import { color } from 'config/color'
import { type ReactNode } from 'react'

interface IDashboardContainer {
  minHeight: string
  justifyContent?: string
  children: ReactNode
}

export const DashboardContainer = ({
  minHeight,
  justifyContent,
  children
}: IDashboardContainer): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={justifyContent ?? 'space-between'}
      bgcolor={color.white}
      borderRadius={1}
      p={3}
      minHeight={minHeight}
    >
      {children}
    </Box>
  )
}
